import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

const US_EXCHANGE_FEE = 0.000119 // 交易费

const HK_COMMISSION_RATE = 0.0012 // 佣金率
const HK_COMMISSION_RATE1 = 0.00005 // 交易费率
const HK_COMMISSION_RATE2 = 0.00002 // 结算交收费率
const HK_COMMISSION_RATE3 = 0.000027 // 交易征费率
const HK_COMMISSION_RATE4 = 0.001 // 印花税率

const HK_EXCHANGE_FEE = 0.5 // 其他交易费
const HK_LOWEST_COMMISSION = 18 // 港股最低佣金
const HK_LOWEST_STAMP_TAX = 1 // 最低印花税
const HK_LOWEST_CLEARING_FEE = 2 // 最低交易所费用
const HK_HIGHEST_CLEARING_FEE = 100 // 最高交易所费用

export default function getTradeMaxQuantity(
  stock,
  availableFunds,
  exchangeRate,
  price
) {
  if (!stock || !availableFunds || !price) return 0
  // 兼容 ib 和 bs，取不同字段
  // 转换成美金计算
  availableFunds = availableFunds * (exchangeRate || 1)

  // 美股计算
  if (MARKET_TYPE.US === stock.market) {
    const dealPrice = price + US_EXCHANGE_FEE

    if (stock.secType === SEC_TYPE.OPT) {
      return Math.floor(availableFunds / dealPrice / 100)
    }
    return Math.floor(availableFunds / dealPrice)
  }

  // 港股计算
  if (MARKET_TYPE.HK === stock.market) {
    const commission = Math.max(
      availableFunds * HK_COMMISSION_RATE,
      HK_LOWEST_COMMISSION
    )
    const exchangeFee = availableFunds * HK_COMMISSION_RATE1 + HK_EXCHANGE_FEE
    const clearingFee = Math.min(
      Math.max(availableFunds * HK_COMMISSION_RATE2, HK_LOWEST_CLEARING_FEE),
      HK_HIGHEST_CLEARING_FEE
    )
    const exchangeTax = availableFunds * HK_COMMISSION_RATE3
    const stampTax = Math.max(
      availableFunds * HK_COMMISSION_RATE4,
      HK_LOWEST_STAMP_TAX
    )
    const availableCash =
      availableFunds -
      commission -
      exchangeFee -
      clearingFee -
      exchangeTax -
      stampTax
    return Math.floor(availableCash / price)
  }
  return 0
}
